import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'

import { Error as ErrorI } from '@/types/error'

export interface ErrorsContextProps {
  formErrors: Record<string, string | undefined> | null
  generalErrors: ErrorI[] | null

  setFormErrors: Dispatch<SetStateAction<Record<string, string | undefined> | null>>
  setGeneralErrors: Dispatch<SetStateAction<ErrorI[] | null>>
}

export const ErrorsContext = createContext({} as ErrorsContextProps)

interface ErrorsProviderProps {
  children: ReactNode
}

export const ErrorsProvider = ({ children }: ErrorsProviderProps) => {
  const [formErrors, setFormErrors] = useState<ErrorsContextProps['formErrors']>(null)
  const [generalErrors, setGeneralErrors] = useState<ErrorsContextProps['generalErrors']>(null)

  const value = {
    formErrors,
    generalErrors,
    setFormErrors,
    setGeneralErrors
  }

  return <ErrorsContext.Provider value={value}>{children}</ErrorsContext.Provider>
}
